<template>
    <div class="form-group">
        
        <form-label 
        v-if="label" 
        :class="labelClass"
        :for="id"
        v-html="$sanitize(label)" />

        <div :class="inline ? 'd-flex align-items-center' : ''">

            <checkbox 
            :class="inline ? 'me-4': ''"
            v-bind="$attrs"
            :key="id+'-'+option.value"
            v-for="option in options"
            v-model="val"
            :value="option.value"
            :label="option.label" />

        </div>

        <form-errors v-bind="{errors}" />
		
    </div>
</template>

<script>

    import { mapState } from 'vuex'

    export default {

        inheritAttrs: false,

        props: {
            id: {
                type: String,
                default() {
                    return `input-radio-${this._uid}`
                },
            },

            options: {
                type: Array,
                default: () => []
            },

            labelClass: {
                type: String,
                default: ''
            },

            single: {
                type: Boolean,
                default: false
            },
			
            errors: {
                type: String,
                default: "",
            },

            inline: {
                type: Boolean,
                default: false
            },

            value: [String, Number, Boolean, Array, Object],
            label: String,
            sublabel: String

        },

        computed: {

            val: {
                get() { 
                    var value = this.value
                    if(_.isArray(value) && this.single) { value = value[0] }
                    return value
                },
                set(value) { 
                    if(_.isArray(value) && this.single) { value = value[0] }
                    this.$emit('input', value) 
                }
            }

        }

    }
</script>
